/* Ratguard About — reveal on scroll.

   Design rule: a decorative animation must never be able to leave content
   permanently invisible. Three independent guards:
     1. rAF-throttled scroll/resize check (the nice effect).
     2. A 400ms poll that calls the check directly — this also clears any
        stuck rAF flag if the tab was throttled or the renderer stalled.
     3. A hard deadline: after 25s everything still hidden is revealed and
        all listeners are torn down.
   Deliberately not IntersectionObserver-only: IO can miss elements jumped
   past in a single frame (anchor jumps, fast momentum scroll, restored
   scroll position). */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-rg-ready') === '1') return;
    root.setAttribute('data-rg-ready', '1');

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-rg-reveal]'));
    if (!items.length) return;

    function revealAll() {
      items.forEach(function (el) { el.classList.add('rg-in'); });
      items = [];
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAll();
      return;
    }

    root.classList.add('rg-anim');

    var ticking = false;
    var waited = 0;
    var poll = null;

    function teardown() {
      if (poll) { clearInterval(poll); poll = null; }
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      document.removeEventListener('visibilitychange', check);
    }

    function check() {
      ticking = false;
      var h = window.innerHeight || document.documentElement.clientHeight;
      // top < 92% of viewport catches elements entering from below AND any
      // element already scrolled above the fold (negative top).
      items = items.filter(function (el) {
        if (el.getBoundingClientRect().top < h * 0.92) {
          el.classList.add('rg-in');
          return false;
        }
        return true;
      });
      if (!items.length) teardown();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('visibilitychange', check);

    poll = setInterval(function () {
      waited += 400;
      check();
      if (waited >= 25000) { revealAll(); teardown(); }
    }, 400);

    check();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rg-about]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-rg-about]') : null;
    init(root);
  });
})();
